const SECRET_PHRASE = "@keron*di5tribution";
const CLIENT_ROL_ID = 7;

export default { SECRET_PHRASE: SECRET_PHRASE, CLIENT_ROL_ID: CLIENT_ROL_ID };
